/* eslint-disable react-hooks/exhaustive-deps */
import { Outlet, useParams } from 'react-router-dom';
import { BsPlusLg } from 'react-icons/bs';
import ReactPaginate from 'react-paginate';

import Box from 'components/ui/box';
import { useAuth } from 'context/AuthContext';
import InputMask from 'react-input-mask';
import { useState, useEffect, useRef } from 'react';
import {
  getResultadosGaleriaReconhecimento,
  getResultadosGaleriaReconhecimentoSecond,
  getResultadosSelosBB,
} from 'services/dashboard.service';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import Avatar from 'funifier-nice-avatar';
import { TbSearch } from 'react-icons/tb';

import './styles.scss';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { GaleriaConhecimentoDetail } from './detail';
import Button from 'components/ui/button';
import CustomSelect from 'components/custom-select';

interface GaleriaProps {
  showHead: (item: boolean) => void;
  options: any;
}

export default function GaleriaReconhecimento({ showHead, options }: GaleriaProps) {
  const [list, setList] = useState<unknown[]>();
  const [selosBB, setSelosBB] = useState<unknown[]>();
  const [page, setPage] = useState(0);
  const [activePag, setActivePag] = useState(0);
  const [showDetail, setShowDetail] = useState('');
  const [isMounted, setIsMounted] = useState(false);

  const [mask] = useState('');

  const searchRef = useRef<any>();

  const [loadingList, setLoadingList] = useState(true);
  const [loadingSelosBB, setLoadingSelosBB] = useState(true);

  const params = useParams();

  const { user } = useAuth();

  const [activeTab, setActiveTab] = useState(0);

  function handleDetail(item: any) {
    setShowDetail(item);
  }

  const getAriaLabel = (pageIndex: number, selected: boolean) => {
    return selected ? `Página ${pageIndex + 1} selecionada` : `Ir para a página ${pageIndex + 1}`;
  };

  useEffect(() => {
    const pageLinks = document.querySelectorAll('.page-link');
    pageLinks.forEach((link, index) => {
      link.setAttribute('aria-label', getAriaLabel(index, link.classList.contains('active')));
    });
  });

  async function loadData(e?: any, itemPage?: number) {
    if (!options?.value) return;

    if (e) {
      e.preventDefault();
    }

    try {
      const rangeItem = itemPage ? itemPage * 20 : 0;

      setActivePag(itemPage ? itemPage : 0);
      setLoadingList(true);
      setList([]);

      const homeSection = document.getElementById('main-body');
      if (homeSection) {
        homeSection.scrollTop = 0;
      }

      const data = await getResultadosGaleriaReconhecimentoSecond(searchRef.current.value, rangeItem, options?.value);

      setPage(data.range.pages);

      setList(data.result);

      setLoadingList(false);

      setIsMounted(true);
    } catch (e) {}
  }

  useEffect(() => {
    if (searchRef.current) {
      searchRef.current.value = '';
    }

    loadData();
  }, [activeTab, options]);

  useEffect(() => {
    showHead(!!showDetail);
  }, [showDetail]);

  if (showDetail) return <GaleriaConhecimentoDetail onClose={() => setShowDetail('')} id={showDetail} tab={options} />;

  return (
    <>
      {!params.id ? (
        <div className="overflow-hidden">
          {/* <div className=" mb-3 lg:mb-10">
            <div className="flex flex-ro items-center space-x-3 lg:space-x-1">
              <h1 className="text-lg lg:text-2xl rounded-full">
                Reconhecimentos recebidos pelos participantes | <span className="text-yellow">{options?.label}</span>
              </h1>
            </div>
          </div> */}

          <div className="mb-5 lg:flex items-center justify-end space-x-5">
            {/* <div className="w-full mb-3 lg:mb-0 lg:w-[264px]">
              <CustomSelect
                placeholder="Clique para selecionar o ciclo"
                options={options}
                value={options[activeTab]}
                onChange={(e: any) => setActiveTab(e.value)}
              />
            </div> */}

            <div className="flex flex-row items-center space-x-4">
              <form onSubmit={e => loadData(e)} className="pl-1 -ml-1 flex-1 flex space-x-5">
                <label htmlFor="search-input" className="sr-only">
                  Pesquise com nome, matrícula, prefixo ou grupo
                </label>
                <InputMask
                  id="search-input"
                  placeholder="Pesquise com nome, matrícula, prefixo ou grupo"
                  alwaysShowMask={false}
                  mask={mask}
                  ref={(ref: any) => {
                    searchRef.current = ref;
                  }}
                  inputMode="search"
                  style={{ fontSize: 16 }}
                  className="min-w-full lg:min-w-[416px] bg-maastricht-blue text-sm text-white font-thin flex-1 rounded-md py-2 px-4"
                  aria-label="Campo de pesquisa"
                />
              </form>

              <button
                type="button"
                onClick={() => loadData(null)}
                className="p-1 hover:ring-2 rounded-full"
                aria-label="Buscar"
              >
                <TbSearch size={28} aria-hidden="true" />
              </button>
            </div>
          </div>

          {activeTab === 1 && (
            <div className="space-y-2 mb-2">
              <p>
                Olá, colega! <br />
                Na Galeria do Reconhecimento estarão os funcionários que mais se destacarem na pontuação final em cada grupo e
                seus nomes serão
                <br />
                divulgados aqui como referências no #JogaJuntoBB. <br />
              </p>

              <p>
                No ciclo 2022/2 estão os funcionários que foram destaques e que participaram da primeira fase Piloto do programa.
              </p>
            </div>
          )}

          {/* <Box className="mb-5">
          <div className="w-full flex flex-col md:flex-row md:justify-center md:items-center space-y-5 md:space-y-0 md:space-x-5 ">
            <Button
              color={activeTab === 0 ? 'featured' : 'outline'}
              className="uppercase py-2"
              onClick={() => setActiveTab(0)}
            >
              Galeria do Reconhecimento
            </Button>
            <Button
              color={activeTab === 1 ? 'featured' : 'outline'}
              className="uppercase py-2"
              onClick={() => setActiveTab(1)}
            >
              Selo BB
            </Button>
          </div>
        </Box> */}

          {/* {activeTab === 0 ? (
          <Box>
            <div className="space-y-5 lg:p-3">
              <div className="text-center">
                <h3 className="text-xl">Em breve</h3>
              </div>
            </div>
          </Box>
        ) : null} */}

          {activeTab === 0 || activeTab === 1 ? (
            <div>
              <Box>
                <div className="space-y-5 lg:p-3">
                  {loadingList && (
                    <div className="space-y-2">
                      <ArticlePlaceholder />
                      <ArticlePlaceholder />
                    </div>
                  )}

                  {!loadingList && list?.length === 0 && (
                    <div className="text-center">
                      <h3 className="text-xl">Nenhum resultado encontrado</h3>
                    </div>
                  )}

                  <div className="space-y-2">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4" role="list">
                      {list?.map((item: any, index) => (
                        <button
                          className="bg-maastricht-blue rounded-xl text-white space-y-2 hover:ring-2 overflow-hidden text-left w-full"
                          key={item?._id + index}
                          onClick={() => handleDetail(item.matricula)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault();
                              handleDetail(item.matricula);
                            }
                          }}
                          aria-label={`Ver detalhes de ${item.nome}, ${item.diretoria} - ${item.funcao}, matrícula ${item.matricula}, grupo: ${item.grupo}`}
                          role="listitem"
                        >
                          <div className="px-4">
                            <div className="flex flex-col items-center justify-around md:h-40 space-y-1 text-center">
                              <div className="w-28 h-28 overflow-hidden rounded-full bg-purple text-3xl font-bold flex flex-row items-center justify-center">
                                {!!item.avatar_type &&
                                  (item.image ? (
                                    <img src={item.image} alt={`Avatar de ${item.nome}`} className="w-full h-full" />
                                  ) : (
                                    <span aria-label={`Inicial ${item.nome[0]}`}>{item.nome[0]}</span>
                                  ))}
                                {!item.avatar_type &&
                                  (!!item.avatar ? <Avatar className="w-full h-full" {...item.avatar} /> : <span aria-label={`Inicial ${item.nome[0]}`}>{item.nome[0]}</span>)}
                              </div>
                            </div>
                          </div>

                          <div className="bg-prussian-blue-3 w-full h-full text-center pb-7 pt-5 ">
                            <div className="font-bold">
                              {item.nome_guerra} - {<span className="font-thin text-electric-blue">{item.matricula}</span>}
                            </div>
                            <span className="font-thin">{item.nome} </span>
                            <div className="mt-0">
                              <span className="text-electric-blue font-thin">{item.diretoria} </span>
                              <span className="font-thin">- {item.funcao}</span>
                            </div>
                            <div className="text-electric-blue mb-3">
                              <span>Grupo: {item.grupo}</span>
                            </div>

                            <div className="mt-4">
                              <BsPlusLg className="mr-2 inline-block" size={17} color="#C2D2FF" aria-hidden="true" />
                              <span className="uppercase">Ver mais</span>
                            </div>
                          </div>
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </Box>
              <nav className={`lg:flex mt-10 justify-center ${page < 2 && 'hidden'}`} aria-label="Navegação de páginas">
                <ReactPaginate
                  pageLinkClassName={'page-link'}
                  activeClassName={'item active '}
                  breakClassName={'item break-me '}
                  breakLabel={'...'}
                  containerClassName={'pagination'}
                  disabledClassName={'disabled-page'}
                  nextClassName={'item next '}
                  pageClassName={'item pagination-page '}
                  previousClassName={'item previous'}
                  initialPage={0}
                  forcePage={activePag}
                  nextLabel={<><IoIosArrowForward style={{ fontSize: 18, width: 150 }} aria-hidden="true" /><span className="sr-only">Próxima página</span></>}
                  onPageChange={data => isMounted ? loadData(null, data.selected) : ''}
                  pageRangeDisplayed={3}
                  pageCount={page}
                  previousLabel={<><IoIosArrowBack style={{ fontSize: 18, width: 150 }} aria-hidden="true" /><span className="sr-only">Página anterior</span></>}
                  ariaLabelBuilder={(pageIndex) => `Ir para a página ${pageIndex}`}
                />
              </nav>
            </div>
          ) : null}

          {activeTab === 3 ? (
            <div className="space-y-5">
              <Box>
                <div className="space-y-5 lg:p-3 text-center">
                  <p className="text-lg text-yellow">
                    O selo é o reconhecimento a quem é destaque na Unidade nos pilares Eficiência, Resultado ou Protagonismo.
                  </p>
                  <p>É concedido pelo Comitê da Unidade e vale 1 bônus de 500 pontos.</p>
                </div>
              </Box>

              <div className="grid grid-cols-3 gap-3 w-full">
                <Box>
                  <div className="space-y-5 lg:p-3">
                    <h4 className="text-xl text-yellow">Protagonismo</h4>
                    <p>
                      Destaque pelo comportamento ativo com foco na construção de uma ideia ou causa com o objetivo de gerar valor
                      para a Empresa.
                    </p>
                  </div>
                </Box>
                <Box>
                  <div className="space-y-5 lg:p-3">
                    <h4 className="text-xl text-yellow">Resultado</h4>
                    <p>
                      Destaque por realizações que impactam positivamente a empresa por meio de resultados consistentes e
                      sustentáveis.
                    </p>
                  </div>
                </Box>
                <Box>
                  <div className="space-y-5 lg:p-3">
                    <h4 className="text-xl text-yellow">Eficiência</h4>
                    <p>
                      Destaque pelo alcance de objetivos relevantes para a empresa, utilizando os recursos disponíveis, com
                      qualidade e prazo excelentes.
                    </p>
                  </div>
                </Box>
              </div>

              <Box>
                <div className="space-y-5 lg:p-3">
                  {loadingSelosBB && (
                    <div className="space-y-2">
                      <ArticlePlaceholder />
                      <ArticlePlaceholder />
                    </div>
                  )}

                  <div className="space-y-2">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                      {selosBB?.map((item: any) => (
                        <div className="bg-black bg-opacity-60 rounded-xl text-gray-300 space-y-2 p-4" key={item?._id}>
                          <div className="flex flex-col items-center justify-around md:h-52 space-y-2 text-center">
                            <div className="text-center">
                              <div className="text-yellow">
                                <b>{item.matricula}</b>
                              </div>
                              <div>{item.nome}</div>
                            </div>
                            <div>
                              <img src={item.image} alt={item.title} className="w-32" />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </Box>
            </div>
          ) : null}
        </div>
      ) : null}
      {/* <GaleriaDetalheModal /> */}
      <Outlet />
    </>
  );
}
